import React from "react";

import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";

import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";

import { useTranslation } from "react-i18next";

const DeleteEmployeeDialog = ({ open, employee, onClose, onConfirm }) => {
  const { t } = useTranslation("UserManagement");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 5,
          width: 420,
          p: 3,
          textAlign: "center",
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <DeleteForeverRoundedIcon
            sx={{
              fontSize: 60,
              color: "error.main",
            }}
          />
        </Box>

        <Typography variant="h6" fontWeight="bold">
          {t("deleteEmployeeTitle")}
        </Typography>

        <Typography color="text.secondary" sx={{ mt: 2 }}>
          {t("deleteEmployeeMessage", {
            name: `${employee?.firstName ?? ""} ${employee?.lastName ?? ""}`,
          })}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            borderRadius: 3,
          }}
        >
          {t("cancel")}
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          sx={{
            borderRadius: 3,
          }}
        >
          {t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteEmployeeDialog;
